export enum CmsBlockWidth {
  GRID = 'GRID',
  INSET = 'INSET',
  NARROW = 'NARROW',
  FULL = 'FULL',
}
